import { useQuery } from '@apollo/client';
import {
  HeaderTag,
  Icon,
  getTranslatedText,
  BackgroundIcon,
  getEntityAttributes,
  ENTITY_MAP,
  validateForm
} from '@nile/components';
import {
  GET_SPLIT_TICKET_ATTRIBUTES,
  GET_ENTITY_PROPERTIES,
  AccountClient
} from '@nile/graphql/src';
import {
  Button,
  ButtonGroup,
  Sheet,
  ResourceItem,
  ResourceList,
  Heading,
  TextField,
  TextStyle
} from '@superops/ui-design-system';
import { Cut } from '@styled-icons/fa-solid/Cut';
import envConfig from '@nile/home/src/Config/env';
import React, { useCallback, useState } from 'react';
import styled from 'styled-components';

import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';

const SplitWrapper = styled.div`
  width: 40vw;
  height: 100vh;
  overflow: auto;
  background: #fff;
  padding: 30px;
  .Polaris-ResourceList__HeaderOuterWrapper {
    display: none;
  }
  .Polaris-ResourceList__HeaderOuterWrapper + .Polaris-ResourceList {
    border-top: 0;
  }
`;

function SplitContainer(props) {
  const { intl } = props;
  const { loading, data, error } = useQuery(GET_SPLIT_TICKET_ATTRIBUTES);
  const {
    loading: metaLoading,
    data: entitiesMeta,
    error: entitiesMetaError
  } = useQuery(GET_ENTITY_PROPERTIES, { client: AccountClient });
  const [subject, setSubject] = useState('');
  const [selectedItems, setSelectedItems] = useState([]);
  const handleSelectedItems = useCallback((value) => {
    setSelectedItems(value);
  });
  const [errors, setErrors] = useState(null);
  if (loading || metaLoading) return <div>loading...</div>;
  if (error) return <div>error...</div>;
  function renderItem(item, id, idx) {
    const { name, label } = item;
    return (
      <div>
        <ResourceItem
          id={item.id}
          accessibilityLabel={`sample`}
          hideSelectedBgColor
        >
          <h3>
            <TextStyle variation="strong">{label}</TextStyle>
          </h3>
        </ResourceItem>
      </div>
    );
  }
  const allEntityFields = getEntityAttributes(entitiesMeta, ENTITY_MAP.ticket);
  const renderItems = data.getTicketAttributesForSplitTicket.map((el) => {
    const attribute = allEntityFields.find((attr) => attr.name === el);
    return {
      name: el,
      value: el,
      label: getTranslatedText(intl, attribute.label || attribute.name),
      id: el
    };
  });
  const stopEvents = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };
  const splitTicket = () => {
    const validationResult = validateForm(
      { subject: subject },
      {
        subject: {
          type: 'string',
          presence: {
            allowEmpty: false
          }
        }
      }
    );
    if (validationResult) {
      setErrors(validationResult);
      return;
    }
    setErrors(null);
    props.splitTicket(subject, selectedItems);
    props.toggleSheetActive();
  };

  const resetState = () => {
    setSubject('');
    setSelectedItems([]);
    props.toggleSheetActive();
  };

  return (
    <SplitWrapper onClick={stopEvents}>
      <div className="flex fcol">
        <div className="flex">
          <div className="fx2 ">
            <Heading element="h1">
              <FormattedMessage id="ticket.details.split.header" />
            </Heading>
          </div>
          <div className="fx fx2 jend actr save-card">
            <div className="fx mlauto">
              <ButtonGroup>
                <Button id="genSheetCancel" onClick={resetState} plain>
                  <FormattedMessage id="common.cancel" />
                </Button>
                <Button
                  id="genSheetDone"
                  onClick={splitTicket}
                  primary
                  icon={<SVGIcon name="Split" color="#fff" />}
                >
                  <FormattedMessage id="ticket.details.split.split" />
                </Button>
              </ButtonGroup>
            </div>
          </div>
        </div>
        {/* <h3 className="flex">
          Copy ticket information
          <ButtonGroup>
            <Button onClick={resetState}>Cancel</Button>
            <Button onClick={splitTicket} primary>
              Split
            </Button>
          </ButtonGroup>
        </h3> */}
        <div className="mt-30">
          <HeaderTag
            title={getTranslatedText(intl, 'ticket.details.split.h2.title')}
            isBgStrip
          />
          <TextField
            id="title"
            value={subject}
            onChange={(val) => {
              setSubject(val);
            }}
            placeholder={getTranslatedText(
              intl,
              'ticket.details.split.title.pl'
            )}
            name="ticketTitle"
            type="text"
            customClassName="Header-Input"
            error={errors?.subject?.[0]}
          />
        </div>
        <div className="mt-30">
          <HeaderTag
            title={getTranslatedText(intl, 'ticket.details.split.properties')}
            isBgStrip
          />
          <ResourceList
            hideSelectAllOption={true}
            items={renderItems}
            renderItem={renderItem}
            selectedItems={selectedItems}
            onSelectionChange={handleSelectedItems}
            selectable
          />
        </div>
      </div>
    </SplitWrapper>
  );
}

function SplitSheet(props) {
  const { intl } = props;
  const [sheetActive, setSheetActive] = useState(false);

  const toggleSheetActive = useCallback(() => {
    setSheetActive((sheetActive) => !sheetActive);
  });
  const selectTicket = useCallback((value) => {
    props.selectTicket(value);
  });
  return (
    <div>
      <div onClick={toggleSheetActive} className="flex pointer g5">
        <div className="flex">
          <SVGIcon name="Split" color="#323232" />
        </div>
        <div>
          <FormattedMessage id="ticket.details.chat.split" />
        </div>
      </div>
      <Sheet open={sheetActive} onClose={toggleSheetActive}>
        <SplitContainer
          intl={intl}
          //actions={props.actions}
          toggleSheetActive={toggleSheetActive}
          {...props}
          selectTicket={selectTicket}
        ></SplitContainer>
      </Sheet>
    </div>
  );
}

export default injectIntl(SplitSheet);
